<div class="aeg-address-details">
    <div class="aeg-address-details__address">
        <address class="aeg-address-details__address" v-if="billingAddress">
            <vl-icon icon="location"/>
            <span :class="{'aeg-address-details__address-unknow': !hasAddress }">{{ billingAddress }}</span>
        </address>
    </div>
    <div class="aeg-address-details__email">
        <vl-icon icon="mail"/>
        <span :class="{'aeg-address-details__email-unknow': !hasEmail }">{{ emailAddress }}</span>
    </div>
</div>